import type { LoadingStateType } from '@/shared/config';

type PreviewFullHeadMprSlicesListener = () => void;

const pendingKeys = new Set<string>();
const failedKeys = new Set<string>();
const listeners = new Set<PreviewFullHeadMprSlicesListener>();

const notify = () => {
  listeners.forEach((listener) => listener());
};

export const registerPreviewFullHeadMprSlices = (key: string) => {
  failedKeys.delete(key);
  pendingKeys.add(key);
  notify();
};

export const markPreviewFullHeadMprSlicesSettled = (key: string) => {
  const wasPending = pendingKeys.delete(key);
  const wasFailed = failedKeys.delete(key);
  if (wasPending || wasFailed) {
    notify();
  }
};

export const markPreviewFullHeadMprSlicesFailed = (key: string) => {
  const wasPending = pendingKeys.delete(key);
  const wasFailed = failedKeys.has(key);
  failedKeys.add(key);
  if (wasPending || !wasFailed) {
    notify();
  }
};

export const unregisterPreviewFullHeadMprSlices =
  markPreviewFullHeadMprSlicesSettled;

export const subscribePreviewFullHeadMprSlices = (
  listener: PreviewFullHeadMprSlicesListener,
) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

export const getPendingPreviewFullHeadMprSlicesCount = () => pendingKeys.size;

export const getPreviewFullHeadMprSlicesStatus = (): LoadingStateType => {
  if (failedKeys.size) {
    return 'failed';
  }

  return pendingKeys.size ? 'pending' : 'succeeded';
};
